import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { FitRelativeWrapper, FlexCenterWrapper, CursorPointerWrapper, Mr1, Px6, Pt4, Mr2, Pb4 } from 'wrappers';
import { SecondaryTextSm300, Icon, SecondaryTextSm } from 'atoms';
import React from 'react';
import internalState from './internalState';
import { DownCaretSvg, LockSvg } from 'components/icons';
import { BodyWrapper } from './wrappers';

const dropdownRef = React.createRef();

export const definition = {
  name: 'PrivacyDropdown',
  controller: Controller,
  initialProps: ({ privacy }) => ({ privacy }),
  props: internalState,
  elements: [
    {
      wrapper: wrap(FlexCenterWrapper, CursorPointerWrapper),
      name: 'HeaderWrapper',
      isButton: true,
      bindings: ({ isOpen }) => ({ isOpen, dropdownRef }),
      elements: [
        {
          component: wrap(SecondaryTextSm300, Mr1),
          name: 'Privacy',
          displayValue: ({ privacy }) => privacy
        },
        {
          component: Icon,
          name: 'Icon',
          displayValue: ({ }) => DownCaretSvg({ color: '#9EACB0' })
        }
      ]
    },
    {
      wrapper: BodyWrapper,
      displayState: ({ }) => ({ background: 'white' }),
      name: 'Body',
      ref: dropdownRef,
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          wrapper: wrap(wrap(wrap(FlexCenterWrapper, CursorPointerWrapper), Px6), Pt4),
          name: 'Public',
          isButton: true,
          bindings: ({ }) => ({}),
          elements: [
            {
              component: wrap(Icon, Mr2),
              name: 'Icon',
              displayValue: ({ }) => LockSvg({ open: true, color: window?.settings?.primary_color ?? '#1DBD6B' })
            },
            {
              component: SecondaryTextSm,
              name: 'Public',
              displayValue: ({ }) => 'Public'
            },
          ]
        },
        {
          wrapper: wrap(wrap(wrap(wrap(FlexCenterWrapper, CursorPointerWrapper), Px6), Pt4), Pb4),
          name: 'Private',
          isButton: true,
          bindings: ({ }) => ({}),
          elements: [
            {
              component: wrap(Icon, Mr2),
              name: 'Icon',
              displayValue: ({ }) => LockSvg({ color: window?.settings?.primary_color ?? '#1DBD6B' })
            },
            {
              component: SecondaryTextSm,
              name: 'Private',
              displayValue: ({ }) => 'Private'
            },
          ]
        },
      ]
    }
  ]
};

const CountDropdown = wrap(ContainerComponent(definition), FitRelativeWrapper);

export default CountDropdown;